import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './PricingSection.css';


const PricingSectionForHome = () => {

  const [pricing, setPricing] = useState([]);


  useEffect(() => {
    fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/pricings`)
      .then((res) => res.json())
      .then((info) => setPricing(info));
  }, []);

  return (


    <>
      <section id='pricing-sec' className="pricing-1 wide-60 pricing-section division">
        <div className="container">
          {/* SECTION TITLE */}
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="section-title mb-50">
                {/* Title 	*/}
                <h3 className="h3-md">Simple And Flexible Pricing</h3>
                {/* Text */}
                <p className="p-lg">
                </p>
              </div>
            </div>
          </div>
          {/* PRICING TABLES	WRAPPER */}
          <div className="pricing-1-wrapper">
            <div className="row">
              {
                pricing.map(b => b.pageSlug === '' && <div className="col-md-4">
                  <div className="pricing-1-table highlight wow fadeInUp" data-wow-delay="0.6s">
                    {/* Plan Price  */}
                    <div className="pricing-plan">
                      <h5 className="h5-lg">{b.packageName} Plan</h5>
                      <sup>$</sup>
                      <span className="price">{b.packagePrice}</span>
                      <sup className="validity"></sup>
                    </div>
                    {/* Pricing Text */}
                    <p className="p-sm grey-color"></p>
                    {/* Pricing Table Button */}

                    {/* Purchase Link */}
                    <Link to={`/order-now/${b._id}`} className="btn btn-primary">{b.packageButtonText}</Link>

                    {/* Pricing Plan Features */}
                    <ul className="features">
                      <li>{b.packagePointOne}</li>
                      <li>{b.packagePointTwo}</li>
                      <li> {b.packagePointThree}</li>
                      <li>{b.packagePointFour}</li>
                      <li>{b.packagePointFive}</li>
                      <li>{b.packagePointSix}</li>
                      <li>{b.packagePointSeven}</li>
                    </ul>
                  </div>
                </div>)}
            </div>  {/* End row */}
          </div>	 {/* END PRICING TABLES WRAPPER */}
        </div>	   {/* End container */}
      </section>

    </>
  );
};

export default PricingSectionForHome;